import { BrowserModule, TransferState } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoggerModule } from 'ngx-logger';
import { environment } from '../environments/environment';
import {
  AngularFirestoreModule,
  SETTINGS as FIRESTORE_SETTINGS,
} from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire';
import {
  AngularFireFunctionsModule,
  NEW_ORIGIN_BEHAVIOR,
  ORIGIN,
} from '@angular/fire/functions';
import { NgAisModule } from 'angular-instantsearch';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { SvgBrowserLoader } from './loaders/svg-browser-loader';
import { AngularSvgIconModule, SvgLoader } from 'angular-svg-icon';
import { FirebaseUIModule } from 'firebaseui-angular';
import { firebaseUiAuthConfig } from './config/firebase-ui-auth';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    TransferHttpCacheModule,
    AppRoutingModule,
    LoggerModule.forRoot({ level: environment.logLevel }),
    AngularFireModule.initializeApp(environment.firebase.config),
    AngularFirestoreModule,
    HttpClientModule,
    NgAisModule.forRoot(),
    AngularSvgIconModule.forRoot({
      loader: {
        provide: SvgLoader,
        useFactory: (transferState, http) =>
          new SvgBrowserLoader(transferState, http),
        deps: [TransferState, HttpClient],
      },
    }),
    FirebaseUIModule.forRoot(firebaseUiAuthConfig),
    AngularFireFunctionsModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: FIRESTORE_SETTINGS,
      useValue: environment.firebase.emulator
        ? {
            host: 'localhost:8080',
            ssl: false,
          }
        : undefined,
    },
    { provide: APP_BASE_HREF, useValue: '' },
    {
      provide: NEW_ORIGIN_BEHAVIOR,
      useValue: true,
    },
    {
      provide: ORIGIN,
      useValue: environment.domain,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
